import { selectQuery } from '../../location/selectors';
import { CohortSchedules } from '../../CohortSchedules/reducers';
import { CourseProgress } from '../../Courses/CourseProgress/reducers';
import { Modules } from '../../Modules/reducers';
import { ModuleProgress } from '../../ModuleProgress/reducers';
import { Kudos } from '../../Kudos/reducers';
import { IssuedBadges } from '../../IssuedBadges/reducers';

import { loadCurrentCourseNavigationData } from '../../CourseNavigationInfo/dispatchers';
import { loadCurrentCourseModuleDisplayData } from '../../Courses/dispatchers';
import { loadCurrentUserKudos } from '../../Kudos/dispatchers';
import { loadCurrentUserIssuedBadges } from '../../IssuedBadges/dispatchers';
import { loadCurrentCourseSubscriptionData } from '../../Courses/dispatchers.common';
import { initialiseCourseNavigationForUserpilot } from '../../routeThunks/userpilot/userpilot';
import { loadLearnersEmailConsentData } from './loadLearnersEmailConsentData';
import { getStripeConnectContext } from '../../CourseAdmin/dispatchers';

const injectReducers = (addReducer) => {
  const inject = () => {
    addReducer('CohortSchedules', CohortSchedules);
    addReducer('CourseProgress', CourseProgress);
    addReducer('Modules', Modules);
    addReducer('ModuleProgress', ModuleProgress);
    addReducer('Kudos', Kudos);
    addReducer('IssuedBadges', IssuedBadges);
  };
  inject();
  if (module.hot) {
    module.hot.accept(
      [
        '../../CohortSchedules/reducers',
        '../../Courses/CourseProgress/reducers',
        '../../Modules/reducers',
        '../../ModuleProgress/reducers',
        '../../Kudos/reducers',
      ],
      () => {
        inject();
      }
    );
  }
};

export const loadCourseNavigationData = ({
  dispatch,
  getState,
  addReducer,
}) => {
  injectReducers(addReducer);
  dispatch(loadCurrentCourseSubscriptionData);
  dispatch(loadCurrentCourseNavigationData);
  dispatch(loadCurrentUserKudos);
  dispatch(loadCurrentUserIssuedBadges);
  dispatch(initialiseCourseNavigationForUserpilot);
  // load learners email consent data on block and non block page of a course
  // and will only be called once there is a current cohort path in store
  dispatch(loadLearnersEmailConsentData);
  dispatch(getStripeConnectContext);

  const query = selectQuery(getState());
  if (query.get('moduleSet')) {
    dispatch(loadCurrentCourseModuleDisplayData);
  }
};
